/**
 * Plugin that marks the app as fully hydrated and ready
 * This is used by end-to-end tests to ensure the app is interactive before testing
 */
export default defineNuxtPlugin({
  name: "app-ready",
  setup() {
    const nuxtApp = useNuxtApp();

    nuxtApp.hook("app:mounted", () => {
      // Add a small delay to ensure all reactive bindings are established
      setTimeout(() => {
        document.body.setAttribute("data-app-ready", "true");
      }, 50);
    });
  },
});
